var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPortMirrorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 14.2826C9.5 13.2261 10.3954 12.3696 11.5 12.3696C12.6046 12.3696 13.5 13.2261 13.5 14.2826V20.5H16.5V14.2826C16.5 13.2261 17.3954 12.3696 18.5 12.3696C19.6046 12.3696 20.5 13.2261 20.5 14.2826V20.5H23.5V14.2826C23.5 11.6412 21.2614 9.5 18.5 9.5C17.1373 9.5 15.9019 10.0215 15 10.8671C14.0981 10.0215 12.8627 9.5 11.5 9.5C8.73858 9.5 6.5 11.6412 6.5 14.2826V20.5H9.5V14.2826Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPortMirrorDark);
export default __webpack_public_path__ + "static/media/icn_port_mirror_Dark.62864746c27cd4e8f5274a6d00fd0b08.svg";
export { ForwardRef as ReactComponent };